"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadFromMFE = exports.LoadMFEStatus = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const uuid_1 = require("uuid");
const useLoadMFE_1 = require("./useLoadMFE");
var LoadMFEStatus;
(function (LoadMFEStatus) {
    LoadMFEStatus["Success"] = "success";
    LoadMFEStatus["Pending"] = "pending";
    LoadMFEStatus["Error"] = "error";
})(LoadMFEStatus = exports.LoadMFEStatus || (exports.LoadMFEStatus = {}));
const LoadFromMFE = ({ importPath, componentName, errorComponent, loader, onError, props, }) => {
    const [data, setData] = (0, react_1.useState)({ status: LoadMFEStatus.Pending });
    const [refreshKey, setRefreshKey] = (0, react_1.useState)("");
    const loadMFE = (0, useLoadMFE_1.useLoadMFE)({ importPath });
    const refreshImport = () => {
        setRefreshKey((0, uuid_1.v4)());
    };
    (0, react_1.useEffect)(() => {
        (async () => {
            const loadedMfe = await loadMFE();
            setData({
                ...loadedMfe,
                status: loadedMfe.status === useLoadMFE_1.UseLoadMFEStatus.Success
                    ? LoadMFEStatus.Success
                    : LoadMFEStatus.Error,
            });
        })();
    }, [loadMFE, refreshKey]);
    (0, react_1.useEffect)(() => {
        if (onError && data.status === LoadMFEStatus.Error) {
            onError(data.error);
        }
    }, [data, onError]);
    switch (data.status) {
        case LoadMFEStatus.Pending:
            return loader ?? react_1.default.createElement(react_1.default.Fragment, null);
        case LoadMFEStatus.Error:
            return react_1.default.cloneElement(errorComponent, {
                onReset: refreshImport,
            });
        default: {
            const Component = data.mfe[componentName];
            return react_1.default.createElement(Component, { ...props });
        }
    }
};
exports.LoadFromMFE = LoadFromMFE;
//# sourceMappingURL=LoadFromMFE.js.map